import { cloneDeep, get, isArray } from 'lodash';
import { GetUpdateDependencies } from '../../pages/private/online-antrag/OnlineAntrag';
import { APIS } from '../constants/apis';
import { PostRecord } from './PostRecord';

// Import schemas
import { ANTRAGS_STATUS } from '../constants/constant';
import AntragSchema from '../paths/antrag_FULL_Paths.json';
import MittelabrufSchema from '../paths/mittelabruf_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;
const P = AntragSchema.attributes;

export async function PushNotificationApplication(api: string, application: any) {
	let entries: any[] = [];

	if (api === APIS.Antrag) {
		const antragStatus = get(application, P.Antragstatus_Antragstatus.path, '');
		if (antragStatus === ANTRAGS_STATUS.FoerderbescheidUebermittelt) {
			entries.push({ api: APIS.Antrag, api_suffix: 'Foerderbescheid', id: get(application, 'id') });
		} else {
			let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));
			for (let ele of relations) {
				if (get(ele, 'api') === APIS.Organisation) {
					entries.push({ api: get(ele, 'api'), id: get(application, `${get(ele, 'field')}.id`) });
				}
			}
			entries.push({ api: APIS.Antrag, id: get(application, 'id') });
			for (let relation of relations) {
				if (get(relation, 'api') !== APIS.Organisation) {
					let values = get(application, get(relation, 'field', []));
					values = isArray(values) ? values : [values];

					for (let value of values) {
						entries.push({ api: get(relation, 'api'), id: get(value, 'id') });
					}
				}
			}
		}
	}
	if (api === APIS.Mittelabruf) {
		entries.push({ api: APIS.Mittelabruf, id: get(application, 'id') });
		let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));

		if (get(application, `${MA_P.Mittelabruf_Verwendungsnachweiss.path}.id`, -1) > 0) {
			// Push Notification for VN only if VN exist
			entries.push({ api: APIS.Verwendungsnachweis, id: get(application, `${MA_P.Mittelabruf_Verwendungsnachweiss.path}.id`) });
		}

		for (let relation of relations) {
			let values = get(application, get(relation, 'field', []));
			values = isArray(values) ? values : [values];

			for (let value of values) {
				entries.push({ api: get(relation, 'api'), id: get(value, 'id') });
			}
		}
	}

	if (api === APIS.Verwendungsnachweis) {
		let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));

		entries.push({ api: APIS.Verwendungsnachweis, id: get(application, 'id') });

		for (let relation of relations) {
			let values = get(application, get(relation, 'field', []));
			values = isArray(values) ? values : [values];

			for (let value of values) {
				entries.push({ api: get(relation, 'api'), id: get(value, 'id') });
			}
		}
	}
	if (api === APIS.Zwischenbericht) {
		entries.push({ api: APIS.Zwischenbericht, id: get(application, 'id') });
	}
	if (api === APIS.Abschlussbericht) {
		entries.push({ api: APIS.Abschlussbericht, id: get(application, 'id') });
	}
	if (api === APIS.AenderungsAnfrage) {
		entries.push({ api: APIS.AenderungsAnfrage, id: get(application, 'id') });
	}

	await PostRecord(APIS.PushNotificaiton, { data: { entities: entries } });
}
